import React, { CSSProperties } from 'react';

export type BreadcrumbProps = {
  Separator?: React.ReactNode;
  className?: string;
  listClassName?: string;
  useSeparatorNode?: boolean;
  style?: CSSProperties;
  dynamicPadding?: boolean;
};

const Breadcrumb = ({
  children,
  Separator,
  className = '',
  listClassName,
  style = undefined,
  useSeparatorNode = false,
  dynamicPadding = false,
}: React.PropsWithChildren<BreadcrumbProps>) => {
  return (
    <nav className={`max-w-[100%] overflow-x-auto scrollbar-hide ${className}`} aria-label="Breadcrumb" style={style}>
      <ol
        role="list"
        className={`flex items-center justify-start gap-12 whitespace-pre ${
          dynamicPadding ? '' : 'px-16'
        } ${listClassName}`}
      >
        {React.Children.map(children, (Child, index) => (
          <>
            <li>
              <button>{Child}</button>
            </li>
            {Separator && (
              <li>
                {index < React.Children.count(children) - 1 && (
                  <>{useSeparatorNode ? Separator : <span>{Separator}</span>}</>
                )}
              </li>
            )}
          </>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
